<template>
  <div class="flex-box bg-white bar-padding">
    <van-nav-bar :title="title">
      <template #left>
        <van-icon
          name="arrow-left"
          size="20"
          color="#333"
          @click="$router.back()"
        />
      </template>
      <template #right>
        <van-icon name="search" size="20" color="#333" @click="goSearch" />
      </template>
    </van-nav-bar>
    <div class="flex-box-main list-content" ref="listContent">
      <van-pull-refresh
        v-model="refishing"
        @refresh="onRefresh"
        class="pull-content"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="product-list">
            <div
              class="product-item"
              v-for="(item, index) in list"
              :key="item.ProId"
              :class="[index % 2 === 0 ? 'item-l' : 'item-r']"
            >
              <ProductItemBox :product="item"></ProductItemBox>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import ProductItemBox from "@/components/ProductItemBox.vue";
import { getSubjectInfo } from "@/api/common";

export default {
  name: "subject",
  components: { ProductItemBox },
  props: ["sid"],
  data() {
    return {
      title: "",
      activeKey: 0,
      subjectId: 0,
      scroll: 0,
      refishing: false,
      list: [],
      loading: false,
      initLoading: false,
      finished: false,
      categories: [],
      query: {
        categoryId: 0,
        pcId: 0,
        sortType: 0,
        size: 10,
        page: 1,
        source: this.$store.getters.source,
        subId: 0,
      },
    };
  },
  created() {
    //this.fetchData();
    this.subjectId = this.$route.params.sid;
    this.query.subId = this.$route.params.sid;
    this.initData();
  },
  beforeRouteEnter(to, from, next) {
    //console.log(to, from);
    if (from.name === "detail") {
      next((vm) => {
        const listContent = vm.$refs.listContent;
        // 记录滚动高度
        listContent.scrollTop = vm.scroll;
        // 不重新请求数据
        //vm.notFetchData()
      });
    } else {
      next((vm) => {
        const listContent = vm.$refs.listContent;
        // 不记录滚动高度
        listContent.scrollTop = 0;
        //vm.refishing = true;
        vm.query.sortType = 0;
        vm.query.subId = vm.$route.params.sid;
        vm.initData();
        // 重新请求数据
        vm.fetchData();
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "detail") {
      let listContent = this.$refs.listContent;
      this.scroll = listContent.scrollTop;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    initData() {
      //console.log(this.$route);
      getSubjectInfo(this.$route.params.sid).then((response) => {
        if (response.data.code === 1) {
          this.title = response.data.data.Title;
          this.query.subId = this.$route.params.sid;
        }
      });
    },
    onRefresh() {
      //this.list = [];
      this.query.page = 1;
      this.finished = false;
      this.loading = true;
      this.loadProduct("refresh");
    },
    fetchData() {
      //console.log(this.$router);
      this.query.page = 1;
      this.loading = true;
      this.finished = false;
      this.loadProduct("fetch");
    },
    loadProduct(f) {
      console.log(f);
      //加载商品信息
      this.$ajax
        .get("api/subject/products", {
          params: this.query,
        })
        .then((response) => {
          this.loading = false;
          this.refishing = false;
          if (response.data.code === 1) {
            let data = response.data.data;
            if (data.length === 0 || data.length < this.query.size) {
              this.finished = true;
              //console.log("完成");
            }
            if (this.query.page === 1) {
              this.list = response.data.data;
            } else {
              this.list = this.list.concat(data);
            }
            this.query.page++; //增加页码
          }
        });
    },
    onLoad() {
      if (this.refishing) {
        this.list = [];
        this.refishing = false;
      }
      this.loadProduct("list");
    },
    onCategoryChange() {
      this.onRefresh();
    },
    onSortChange() {
      this.onRefresh();
    },
    goSearch() {
      this.$router.push({ name: "search", query: { from: "subject" } });
    },
  },
};
</script>

<style lang="less" scoped>
.list-content {
  display: flex;
  overflow-y: auto;
  padding-top: 10px;
  background-color: #f5f5f5;
}
.product-list {
  display: flex;
  flex-wrap: wrap;
  .product-item {
    width: 50%;
    box-sizing: border-box;
    padding: 0 10px 10px 10px;
  }
  .item-l {
    padding-right: 5px;
  }
  .item-r {
    padding-left: 5px;
  }
}
</style>
